export const HEADER = {
  logo: {
    src: '/Asset/logo.png',
    alt: "Nayan N.",
  },
  menus: [
    {
      name: ".home( )",
      to: "Hero",
    },
    {
      name: ".about( )",
      to: "About",
    },
    {
      name: ".resume( )",
      to: "Resume",
    },
    {
      name: ".works( )",
      to: "Portfolio",
    },
    // {
    //   name: "Blogs",
    //   to: "Blogs",
    // },
    {
      name: ".contact( )",
      to: "Contact", 
    },
  ],
};
